// extracted by mini-css-extract-plugin
module.exports = {"iconBorder":"CreditIcon_iconBorder__rU7oS","iconWrap":"CreditIcon_iconWrap__TxbKT","iconImg":"CreditIcon_iconImg__2cwlX"};